module.exports = __webpack_public_path__ + "static/DEV0-6deef4eeb50381c2aea50c02815201b5.jpg";